export default __webpack_public_path__ + "static/media/daily_stock.51e1b4c3.svg";